import React from 'react';
import PropTypes from 'prop-types';
import Col from "../Layout/Col";
import Row from "../Layout/Row";

var FormGroup = function FormGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      horizontal = _ref.horizontal;
  return horizontal ? /*#__PURE__*/React.createElement(Row, {
    className: className,
    style: style,
    wrap: false,
    spacing: 4
  }, children) : /*#__PURE__*/React.createElement(Col, {
    className: className,
    style: style,
    spacing: 2
  }, children);
};

FormGroup.defaultProps = {
  className: '',
  style: {},
  horizontal: false
};
FormGroup.propTypes = {
  /** Form Group inner children */
  children: PropTypes.node.isRequired,

  /** Class  to be added to FormGroup */
  className: PropTypes.string,

  /** Style to add to FormGroup */
  style: PropTypes.shape(),

  /** Boolean to indicate if Form group should be horizontal or not */
  horizontal: PropTypes.bool
};
export default FormGroup;